module.exports = __webpack_public_path__ + "static/media/iconExcel.9f7dab28.png";